import { BUCKETS } from "@/constants";
import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { duplicateFolderInStorage } from "@/services/supabase/storage/actions/dupplicateFolderInStorage";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const createTemplateFromPromptbook = async (promptbookId: string, teamId?: string) => {
  const userId = teamId || (await getUserId());
  const { data: templateId, error } = await supabase.rpc("create_template_from_promptbook", {
    original_resource_id: promptbookId,
    owner_id: userId,
  });

  if (templateId) {
    await duplicateFolderInStorage(
      BUCKETS.promptbooks,
      `${promptbookId}/files`,
      BUCKETS["promptbook-templates"],
      `${templateId}/files`,
    );
  }

  return { templateId, error };
};

export const useCreateTemplateFromPromptbook = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: ({ promptbookId, teamId }: { promptbookId: string; teamId?: string }) =>
      createTemplateFromPromptbook(promptbookId, teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({ predicate: (query) => query.queryKey?.[0] === "promptbook_templates" });
    },
  });
  return mutateAsync;
};
